export default "__VITE_ASSET__ti$A2KAu__"